<template>
    <v-dialog
      lazy
      v-model="progressData.dialog"
      max-width="500px"
      style="z-index: 500"
      :persistent="true"
    >
      <v-card>
        <v-toolbar color="white" dense flat style="padding:0">
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark flat @click="cancel">
              <v-icon color="#999">close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-flex class="text-xs-center">
          <v-progress-circular :rotate="-90" :size="100" :width="7" :value="progressData.progress">{{progressData.progress}}%</v-progress-circular>
        </v-flex>
        <v-card-text class="text-xs-center blue-title">Upload remaining time {{progressData.time}}</v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    data:()=>({
      progressData:{
            dialog:false,
            progress:'',
            time:'',
            seconds:0
        },
      timerEnable:false,
      timerIndex:0,
      events:[]
    }),
    methods:{
      open(progress,seconds){
        if(!this.progressData.dialog){
          this.progressData.dialog = true;
        }
        if(!this.timerEnable){
          this.timer()
        }

        this.progressData.seconds = seconds;
        this.progressData.progress = progress;
      },
      registerEvent(evt){
        if(evt && typeof(evt) === "function") {
        this.timerEnable = false
        if(this.timerIndex>0){
            clearTimeout(this.timerIndex)
        }
        this.events.push(evt)
        }
      },
      cancel(){
        this.progressData.dialog=false

        var evt=this.events.pop()
        if(evt && typeof(evt) === "function") {
            evt()
            this.events=[]
        }
      },

      timer(){
        if(!this.progressData.seconds){
          this.progressData.seconds=0
        }
        
        this.progressData.seconds-=1
        if(this.progressData.seconds<=0){
          return
        }
        this.timerEnable=true
        let minute=Math.round(this.progressData.seconds/60)
        let second=this.progressData.seconds % 60
        this.progressData.time=`${(minute<10?'0':'')}${minute}:${(second<10?'0':'')}${second}`

        this.timerIndex=setTimeout(() => {
          this.timer()
        }, 1000);
      }
    },
    watch:{
      'progressData.progress':function(value){
        if(value && value==100){
          setTimeout(()=>{
            this.progressData.dialog = false;
          },1500)
        }
      }
    }
}
</script>